import { ReactNode } from 'react';
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';
import { clsx } from 'clsx';
import { IWithClassname } from '@/models/common';
import s from './ControlledScoreSelect.module.scss';

interface Props extends IWithClassname {
  fieldName: string;
  label?: string | ReactNode;
  rules?: RegisterOptions;
}

const maxScore = 5;

export const ControlledScoreSelect = (props: Props) => {
  const {
    fieldName,
    label,
    className,
  } = props;
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={fieldName}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <div className={clsx(s.wrapper, className)}>
          {label && <div className={s.label}>{label}</div>}
          <ul className={s.stars}>
            {Array(maxScore).fill('').map((_, i) => {
              return (
                <li key={i}>
                  <button type={'button'} onClick={() => value === i + 1 ? onChange(0) : onChange(i + 1)}>
                    <svg
                      className={clsx(s.stars__star, { [s.stars__star_active]: i < value })}
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                        fill="#E1DCEB" />
                    </svg>
                  </button>
                </li>
              );
            })}
          </ul>
          <span className={clsx(s.errorHint, { [s.errorHint_visible]: error })}>
            {error?.message}
          </span>
        </div>
      )}
    />
  );
};